import { withInstall } from '@code-monkey-ui/utils'
import Statistic from './src/statistic.vue'

export const ElStatistic = withInstall(Statistic)

export default ElStatistic
export * from './src/statistic'
